export const brandName = "C’est qui le Patron ?!";
export const description = `Nous consommateurs « ${brandName} » créons notre propre marque de produits, co-construits en soutien aux producteurs. Rejoignez-nous !`;
export const themeColor = "#0077c8";
